import { ValueRange } from '../value-range'
import { EVCStation } from '../location/evcstation'

export class EVCharger {
    id: string
    manufacturer: string
    serialNumber: string
    type: EVChargerType
    status: EVChargerStatus
    model: string 
    sendDataTransfer?: string   
    installationStatus?: EVChargerInstallationStatus

    primaryCommunicaiton?: EVChargerCommunication
    secondaryCommunicaiton?: EVChargerCommunication
    pndEffectiveOn?: Date
    retEffectiveOn?: Date
    outputs?: EVChargerOutput[]

    //reverse reference
    station?: EVCStation

    constructor(id: string, manufacturer: string, serialNumber: string, type: EVChargerType, status: EVChargerStatus, model: string, sendDataTransfer?: string, installationStatus?: EVChargerInstallationStatus, primaryCommunication?: EVChargerCommunication, secondaryCommunication?: EVChargerCommunication, pndEffectiveOn?: Date, retEffectiveOn?: Date, outputs?: EVChargerOutput[]) {
        this.id = id
        this.manufacturer = manufacturer
        this.serialNumber = serialNumber
        this.type = type
        this.status = status
        this.model = model
        this.sendDataTransfer = sendDataTransfer
        this.installationStatus = installationStatus

        this.primaryCommunicaiton = primaryCommunication
        this.secondaryCommunicaiton = secondaryCommunication
        this.pndEffectiveOn = pndEffectiveOn
        this.retEffectiveOn = retEffectiveOn
        this.outputs = outputs
    }
}

export class EVChargerType {
    id: string
    name?: string
    inputVoltage?: number
    inputPhase?: number
    chargerOutputType?: string
    outputTypes?: EVChargerOutputType[]
    chargerTypeGroup?: string

    constructor(id: string, name?: string, inputVoltage?: number, inputPhase?: number, chargerOutputType?: string, outputTypes?: EVChargerOutputType[], chargerTypeGroup?: string) {
        this.id = id
        this.name = name
        this.inputVoltage = inputVoltage
        this.inputPhase = inputPhase
        this.chargerOutputType = chargerOutputType
        this.outputTypes = outputTypes
        this.chargerTypeGroup = chargerTypeGroup
    }
}

export class EVChargerCommunication {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}

export class EVChargerStatus {
    id: string
    name: string
    remarks?: string
    additionalinfo?: string

    constructor(id: string, name: string, remarks: string, additionalinfo: string) {
        this.id = id
        this.name = name
        this.remarks = remarks
        this.additionalinfo = additionalinfo
    }
}

export class EVChargerInstallationStatus {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}

export class EVChargerOutput {
    id: string
    number: number
    type: EVChargerOutputType
    ports: EVChargerOutputPort[] 
    tag?: string // this tag is chaged from tag to tag? that is optional peramater as per new requirements   
    status?: EVChargerOutputStatus

    constructor(id: string, number: number, type: EVChargerOutputType, ports: EVChargerOutputPort[], tag?: string, status?: EVChargerOutputStatus) {
        this.id = id
        this.number = number
        this.type = type
        this.ports = ports
        this.tag = tag
        this.status = status
    }
}

export class EVChargerOutputType {
    id: string
    name: string
    volt: number
    phase: number
    kwRange: ValueRange
    currentRange: ValueRange
    portTypes: EVChargerOutputPortType[]
    outputType: string
    statuses?: EVChargerOutputStatus[] 
    
    constructor(id: string, name: string, volt: number, phase: number, kwRange: ValueRange, currentRange: ValueRange, portTypes: EVChargerOutputPortType[], outputType: string, statuses?: EVChargerOutputStatus[]) {
        this.id = id
        this.name = name
        this.volt = volt
        this.phase = phase
        this.kwRange = kwRange
        this.currentRange = currentRange
        this.portTypes = portTypes
        this.outputType = outputType
        this.statuses = statuses
    }
}


export class EVChargerOutputStatus {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}

export class EVChargerOutputPortType {
    id: number
    name: string
    image: string
    statuses?: EVChargerOutputPortStatus[]

    constructor(id: number, name: string, image: string, statuses?: EVChargerOutputPortStatus[]) {
        this.id = id
        this.name = name
        this.image = image
        this.statuses = statuses
    }
}

export class EVChargerOutputPort {
    id: number
    type: string
    status?: EVChargerOutputPortStatus

    constructor(id: number, type: string, status?: EVChargerOutputPortStatus) {
        this.id = id
        this.type = type
        this.status = status
    }
}

export class EVChargerOutputPortStatus {
    id: string
    name: string

    constructor(id: string, name: string) {
        this.id = id
        this.name = name
    }
}
//25.03.2021 qr code download service
export class QRcode {
    chargerId: string
    outputId: string

    constructor(id: string, name: string) {
        this.chargerId = id
        this.outputId = name
    }
}